<template>
  <v-container max-width="100%" fluid style="margin-top: 2%;">
    <!-- Dialogo de confirmação de exclusão -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500" style="border-radius: 10px;">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('system.alert') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{ $t('button.dismiss')
                }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="deleteFromDatabase">{{
                $t('button.confirm') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-overlay :value="savingBulk" z-index="6000">
      <div class="d-flex flex-column align-center">
        <v-progress-circular indeterminate size="56" color="white"></v-progress-circular>
        <span class="mt-4">{{ $t('guide.savingBulk', { total: savingBulkTotal }) }}</span>
      </div>
    </v-overlay>

    <MerusDataTable :headers="headers" :items="guiasFiltered" :loading="loadingGuias" :default-multi-sort="defaultSort"
      :loading-text="$t('guide.loading_guides')" @update:displayedItems="displayedItemsForExport = $event"

 cod-tabela="GUIAS" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <CadastroToolbar :token="token" :user="user.id_usuario" :title="$t('schedule.title2')" hide-search
          :items="itemsForCsvExport" :csv-title="$t('schedule.title2')" :csv-headers="headersCSV" :pdf-title="$t('schedule.title2')"
          :pdf-headers="headers" :export-headers="exportHeaders" :pdf-filename="$t('schedule.title2')" :help-dialog-csv-fields="helpCSV"
          :help-dialog-csv-model="$t('schedule.title2')" :endpoint-upload-csv="canEdit || canInsert ? '/api/v1.0/processacsvguias/' : null"
          :templates-csv="templatesCSV" @saveBulk="saveBulk">

          <template v-slot:extension>
            <v-row>
              <v-col cols="12" sm="12" md="3">
                <v-autocomplete
                  v-model="idUnidadeFiltroLista"
                  :items="unidades"
                  item-text="descricao_unidade"
                  item-value="id_unidade"
                  :label="$t('guide.selectUnit')"
                  clearable
                  dense
                  hide-details
                  class="mt-3"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-datetime-picker :label="$t('datetime.from')" v-model="dateToFilterLower"
                  :time-picker-props="timeProps" :text-field-props="textFieldProps" time-format="HH:mm:ss"
                  date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')"
                  style="align-self: flex-end; margin-top: 5px;">
                  <template slot="dateIcon">
                    <v-icon>mdi-calendar</v-icon>
                  </template>
                  <template slot="timeIcon">
                    <v-icon>mdi-clock</v-icon>
                  </template>
                </v-datetime-picker>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-datetime-picker :label="$t('datetime.until')" v-model="dateToFilterHigher"
                  :time-picker-props="timeProps" :text-field-props="textFieldProps" time-format="HH:mm:ss"
                  date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')"
                  style="align-self: flex-end; margin-top: 5px;">
                  <template slot="dateIcon">
                    <v-icon>mdi-calendar</v-icon>
                  </template>
                  <template slot="timeIcon">
                    <v-icon>mdi-clock</v-icon>
                  </template>
                </v-datetime-picker>
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn fab dark color="primary" @click="populaGuias" small class="mt-3" v-on="on">
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                  </template>
                  <div>{{ $t('guide.reload') }}</div>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
          </template>

          <template v-slot:add v-if="canInsert">
            <v-dialog v-model="dialog" fullscreen max-width="100%">
              <!-- botão para mostrar o dialog de cadastro/edição de guias -->
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-toolbar dark color="primary">
                  <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="save">{{ $t('button.save') }}</v-btn>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <LazySelect
                            ref="empresaSelect"
                            get-url="getEmpresaslazy"
                            text="razao_social"
                            value="id_empresa"
                            :label="$t('area.selectCompany')"
                            :rules="[(v) => !!v || $t('guide.validation.companyRequired')]"
                            :disabled="isIdEmpresaDisabled"
                            @input="onEmpresaInput"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.guia_original" :label="$t('guide.code')"
                            :rules="[(v) => !!v || $t('guide.validation.codeRequired')]"
                            :disabled="isCodigoDisabled"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                          <v-text-field v-model="editedItem.roleta_inicial" :label="$t('guide.initialTurnstile')"
                            :rules="[(v) => (!v || v > 0) || $t('guide.validation.turnstileGreaterThanZero')]"
                            :disabled="isRoletaInicialDisabled"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                          <v-text-field v-model="editedItem.roleta_final" :label="$t('guide.finalTurnstile')"
                            :rules="[(v) => (!v || v > 0) || $t('guide.validation.turnstileGreaterThanZero')]"
                            :disabled="isRoletaFinalDisabled"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <LazySelect
                            ref="unidadeSelect"
                            get-url="getUnidadeslazy"
                            text="descricao_unidade"
                            value="id_unidade"
                            :label="$t('guide.selectUnit')"
                            :disabled="isIdRotaDisabled"
                            @input="onUnidadeInput"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <LazySelect
                            ref="linhaSelect"
                            get-url="getLinhaslazy"
                            text="nome_linha"
                            value="id_linha"
                            :label="$t('guide.selectLine')"
                            :rules="[(v) => !!v || $t('guide.validation.lineRequired')]"
                            :disabled="isIdRotaDisabled"
                            :extra-data="unidadeLazyExtraData"
                            @input="onLinhaInput"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-autocomplete v-model="editedItem.id_veiculo" :items="veiculosFiltrados" item-text="numero_ordem"
                            item-value="id_veiculo" auto :label="$t('guide.selectVehicle')"
                            :disabled="isVeiculoDisabled"
                            :rules="[(v) => !!v || $t('guide.validation.vehicleRequired')]"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <LazySelect
                            ref="turnoSelect"
                            get-url="getTurnoslazy"
                            text="descricao_turno"
                            value="id_turno"
                            :label="$t('guide.turn')"
                            :disabled="isTurnoDisabled"
                            :rules="[(v) => !!v || $t('guide.validation.turnRequired')]"
                            :extra-data="unidadeLazyExtraData"
                            @input="onTurnoInput"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.escalonamento" type="number" :label="$t('guide.escalation')"
                            :disabled="isTurnoDisabled"
                            :rules="[(v) => !!v && v > 0 || $t('schedule.escalationRequired')]">
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="5" md="5">
                          <v-datetime-picker :label="$t('datetime.pickupHour')" ref="horaPegadaProgramadaInput"
                            v-model="horaPegadaProgramada" :time-picker-props="timeProps"
                            :text-field-props="textFieldProps" time-format="HH:mm" date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')" :disabled="isHoraPegadaDisabled">
                            <template slot="dateIcon">
                              <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                              <v-icon>mdi-clock</v-icon>
                            </template>
                          </v-datetime-picker>
                        </v-col>
                        <v-col cols="12" sm="5" md="5">
                          <v-datetime-picker :label="$t('datetime.departureTime')" ref="horaLargadaProgramadaInput"
                            v-model="horaLargadaProgramada" :time-picker-props="timeProps"
                            :text-field-props="textFieldPropsLargada" time-format="HH:mm" date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')" :disabled="isHoraLargadaDisabled">
                            <template slot="dateIcon">
                              <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                              <v-icon>mdi-clock</v-icon>
                            </template>
                          </v-datetime-picker>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                          <v-select :label="$t('guide.status')" v-model="editedItem.status" :items="status"
                            item-text="descricao_status_guia" item-value="id_status_guia"
                            :disabled="isStatusDisabled"></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-autocomplete v-model="editedItem.id_motorista" :items="motoristasFiltrados" item-text="label"
                            item-value="id_funcionario" auto :label="$t('guide.selectMotorist')"
                            :rules="[(v) => !!v || $t('guide.validation.motoristRequired')]"
                            :disabled="isMotoristaDisabled"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <v-autocomplete v-model="editedItem.id_cobrador" :items="cobradoresFiltrados" item-text="label"
                            item-value="id_funcionario" auto :label="$t('guide.selectCollector')"
                            :disabled="isCobradorDisabled"></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-select v-model="idQuadroSelected" :items="quadrosFiltered" item-text="descricao"
                            item-value="id_quadro" :label="$t('guide.selectTimeTable')" clearable
                            :disabled="isQuadroDisabled" @change="onQuadroChanged"></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <v-select v-model="editedItem.id_viagem" :items="viagens" item-text="descricao_viagem"
                            item-value="id_viagem" :label="$t('guide.selectTrip')" clearable
                            :disabled="isViagemDisabled"></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="4">
                          <v-autocomplete v-model="editedItem.ponto_partida" :items="cercasFiltradas" item-text="nome_cerca"
                            item-value="id_cerca" :label="$t('guide.selectStartPoint')" clearable
                            :disabled="isPontoPartidaDisabled"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="4">
                          <v-autocomplete v-model="editedItem.ponto_chegada" :items="cercasFiltradas" item-text="nome_cerca"
                            item-value="id_cerca" :label="$t('guide.selectEndPoint')" clearable
                            :disabled="isPontoChegadaDisabled"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="4">
                          <v-select v-model="editedItem.id_classificacao_viagem" :items="classificacoesViagens" item-text="descricao_classificacao"
                            item-value="id_classificacao" :label="$t('guide.selectCategory')" clearable
                            :disabled="isClassificacaoViagemDisabled"></v-select>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </CadastroToolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="green" @click="editItem(item)"
          :disabled="isGuiaEditable(item) || !canEdit || !canInsert">mdi-pencil</v-icon>
      </template>
    </MerusDataTable>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import DateUtils from "../utils/dateutils";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import LazySelect from "@/components/Selects/LazySelect.vue";
import EventBus from '../utils/eventBus';
import translateDbField from "@/utils/translateDbField";

/** Uma unidade tem poucas linhas: uma pagina so ja traz todas (getlinhaslazy devolve 6 colunas). */
const LINHAS_POR_UNIDADE_PAGE_SIZE = 2000;

export default {
  components: {
    MerusDataTable,
    CadastroToolbar,
    LazySelect,
  },
  data: () => ({
    headers: [],
    search: "",
    searchFuncionarios: "",
    user: null,
    token: null,
    showConfirmButton: true,
    formValidado: true,
    formValidadoFuncionarios: true,
    mensagemUpload: "",
    dialog: false,
    operacao: 0,
    isAtivo: false,
    confirmDialog: false,
    uploadDialog: false,
    helpDialog: false,
    mensagemdialog: "",
    disableEmpresa: false,
    disableIdLinha: false,
    disableIdRota: false,
    disableDataEscala: false,
    // disableQtdDias: true,
    disableInsertFuncionario: false,
    disableVeiculo: false,
    disableMotorista: false,
    disableCobrador: false,
    disableStatus: false,
    disableViagem: false,
    disableTurno: false,
    disableHoraPegada: false,
    disableHoraLargada: false,
    disablePontoPartida: false,
    disablePontoChegada: false,
    disableCodigo: false,
    disableRoletaInicial: false,
    disableRoletaFinal: true,
    disableQuadro: false,
    disableClassificacaoViagem: false,
    modalDataEscala: false,
    horaPegadaProgramada: null,
    horaLargadaProgramada: null,
    loadingfuncionarios: false,
    dialogFuncionarios: false,
    editingFuncionarios: false,
    loadingGuias: false,
    savingBulk: false,
    savingBulkTotal: 0,
    dateToFilterLower: null,
    dateToFilterHigher: null,
    uploadResultDialog: false,
    resultCSV: [],
    showSaveButton: false,
    templatesCSV: [
      { id: 1, description: "Merus", endpoint: "/api/v1.0/processacsvguias/" },
      { id: 2, description: "Globus", endpoint: "/api/v1.0/processacsvguiasmimo/" }],
    textFieldPropsLargada: {
      prependInnerIcon: "mdi-calendar",
    },
    timeProps: {
      useSeconds: false,
    },
    guias: [],
    displayedItemsForExport: null,
    funcionarios: [],
    funcionariosGuia: [],
    motoristas: [],
    cobradores: [],
    /** Cache id_linha -> registro completo da linha (getalllinhas paginado por id). */
    linhaDetalhePorId: {},
    /** Buscas de detalhe em andamento, por id_linha (evita requisicao duplicada). */
    linhaDetalheEmVoo: {},
    /** Cache id_unidade -> Set de ids de linhas da unidade (getlinhaslazy por unidade). */
    idsLinhasPorUnidadeCache: {},
    linhasupload: [],
    rotasupload: [],
    veiculos: [],
    empresas: [],
    status: [],
    viagens: [],
    cercas: [],
    turnos: [],
    quadros: [],
    unidades: [],
    classificacoesViagens: [],
    idUnidadeSelecionada: null,
    idUnidadeFiltroLista: null,
    idQuadroSelected: null,
    config: null,
    editedIndex: -1,
    guiaOriginal: null,
    guiaEditSnapshot: null,
    editedItem: {
      id_linha: null,
      id_empresa: null,
      id_guia: null,
      id_rota: null,
      id_veiculo: null,
      status: null,
      status_extenso: null,
      hora_pegada: null,
      hora_largada: null,
      data_hora_pegada: null,
      data_hora_largada: null,
      turno: null,
      id_motorista: null,
      id_cobrador: null,
      ativa: null,
      ativa_extenso: null,
      alteracao_manual: null,
      dt_alteracao_manual: null,
      id_usuario_alteracao_manual: null,
      guia_original: null,
      ponto_partida: null,
      ponto_chegada: null,
      id_viagem: null,
      escalonamento: null,
      id_classificacao_viagem: null,
    },
    deletedItem: {
      id_linha: null,
      id_empresa: null,
      id_guia: null,
      id_rota: null,
      id_veiculo: null,
      status: null,
      status_extenso: null,
      hora_pegada: null,
      hora_largada: null,
      data_hora_pegada: null,
      data_hora_largada: null,
      turno: null,
      id_motorista: null,
      id_cobrador: null,
      ativa: null,
      ativa_extenso: null,
      alteracao_manual: null,
      dt_alteracao_manual: null,
      id_usuario_alteracao_manual: null,
      guia_original: null,
      ponto_partida: null,
      ponto_chegada: null,
      id_viagem: null,
      escalonamento: null,
      id_classificacao_viagem: null,
    },
    defaultItem: {
      id_linha: null,
      id_empresa: null,
      id_guia: null,
      id_rota: null,
      id_veiculo: null,
      status: null,
      status_extenso: null,
      hora_pegada: null,
      hora_largada: null,
      data_hora_pegada: null,
      data_hora_largada: null,
      turno: null,
      id_motorista: null,
      id_cobrador: null,
      ativa: null,
      ativa_extenso: null,
      alteracao_manual: null,
      dt_alteracao_manual: null,
      id_usuario_alteracao_manual: null,
      guia_original: null,
      ponto_partida: null,
      ponto_chegada: null,
      id_viagem: null,
      escalonamento: null,
      id_classificacao_viagem: null,
    },
    formUploadValidado: true,
    idempresaupload: null,
    arquivoCsv: null,
    fileLoading: false,
    fimProcesso: false,
    arquivoLog: null,
    uploadMessageColor: "primary",
    importar_guias_csv: false,
    recursos: [],
    empresasPermitidas: [],
    canInsert: false,
    canEdit: false,
    canDelete: false,
    syncingLazySelects: false,
  }),
  computed: {
    headersFuncionarios() {
      return [
        { text: this.$t('guide.headersFuncionarios.id'), value: "id_funcionario", align: " d-none" },
        { text: this.$t('guide.headersFuncionarios.name'), value: "nome" },
        { text: this.$t('guide.headersFuncionarios.category'), value: "categoria_extenso" },
        { text: this.$t('guide.headersFuncionarios.actions'), value: "actions", sortable: false }]
    },
    headersCSV() {
      return [
        { text: this.$t('guide.headersCSV.lineNumber'), value: "line_number", error: "error_line" },
        { text: this.$t('guide.headersCSV.company'), value: "cod_empresa", error: "error_empresa" },
        { text: this.$t('guide.headersCSV.guide'), value: "guia_original", error: "error_guia_original" },
        { text: this.$t('guide.headersCSV.vehicle'), value: "cod_veiculo", error: "error_veiculo" },
        { text: this.$t('guide.headersCSV.line'), value: "cod_linha", error: "error_linha" },
        { text: this.$t('guide.headersCSV.driver'), value: "matricula_motorista", error: "error_motorista" },
        { text: this.$t('guide.headersCSV.collector'), value: "matricula_cobrador", error: "error_cobrador" },
        { text: this.$t('guide.headersCSV.pickupDate'), value: "data_hora_pegada", error: "error_dt_pegada", warning: "warning_dt_pegada" },
        { text: this.$t('guide.headersCSV.departureDate'), value: "data_hora_largada", error: "error_dt_largada", warning: "warning_dt_largada" },
        { text: this.$t('guide.headersCSV.turn'), value: "turno", error: "error_turno" },
        { text: this.$t('guide.headersCSV.escalation'), value: "escalonamento", error: "error_escalonamento" },
        { text: this.$t('guide.headersCSV.openingDate'), value: "data_abertura_erp", error: "error_dt_abertura_erp", warning: "warning_dt_abertura_erp" },
        { text: this.$t('guide.headersCSV.closingDate'), value: "data_fechamento_erp", error: "error_dt_fechamento_erp", warning: "warning_dt_fechamento_erp" },
        { text: this.$t('guide.headersCSV.startFence'), value: "cod_cerca_inicio", error: "error_cerca_inicio" },
        { text: this.$t('guide.headersCSV.endFence'), value: "cod_cerca_final", error: "error_cerca_final" },
        { text: this.$t('guide.headersCSV.status'), value: "cod_status_guia", error: "error_status_guia" },
        { text: this.$t('guide.headersCSV.category'), value: "cod_classificacao_viagem", error: "error_classificacao_viagem" }]
    },
    defaultSort() {
      return [
        { value: 'ativo_extenso', options: { text: this.$t('system.labels.decreasing'), value: -1 } },
        { value: 'dt_pegada', options: { text: this.$t('system.labels.decreasing'), value: -1 } }]
    },
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        style: "margin-top: 20px;",
        rules: [(v) => !!v || this.$t('rules.messageDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
      }
    },
    helpCSV() {
      return [
        {
          label: this.$t('guide.csv.companyCode'),
          description: this.$t('guide.csv.companyCodeDesc'),
          key: "cod_empresa",
          example: this.$t('guide.csv.example.companyCode')
        },
        {
          label: this.$t('guide.csv.guideCode'),
          description: this.$t('guide.csv.guideCodeDesc'),
          key: "guia_original",
          example: this.$t('guide.csv.example.guideCode')
        },
        {
          label: this.$t('guide.csv.vehicleCode'),
          description: this.$t('guide.csv.vehicleCodeDesc'),
          key: "cod_veiculo",
          example: this.$t('guide.csv.example.vehicleCode')
        },
        {
          label: this.$t('guide.csv.lineCode'),
          description: this.$t('guide.csv.lineCodeDesc'),
          key: "cod_linha",
          example: this.$t('guide.csv.example.lineCode')
        },
        {
          label: this.$t('guide.csv.driverRegistration'),
          description: this.$t('guide.csv.driverRegistrationDesc'),
          key: "matricula_motorista",
          example: this.$t('guide.csv.example.driverRegistration')
        },
        {
          label: this.$t('guide.csv.collectorRegistration'),
          description: this.$t('guide.csv.collectorRegistrationDesc'),
          key: "matricula_cobrador",
          example: this.$t('guide.csv.example.collectorRegistration')
        },
        {
          label: this.$t('guide.csv.pickupDate'),
          description: this.$t('guide.csv.pickupDateDesc'),
          key: "data_hora_pegada",
          example: this.$t('guide.csv.example.pickupDate')
        },
        {
          label: this.$t('guide.csv.departureDate'),
          description: this.$t('guide.csv.departureDateDesc'),
          key: "data_hora_largada",
          example: this.$t('guide.csv.example.departureDate')
        },
        {
          label: this.$t('guide.csv.turn'),
          description: this.$t('guide.csv.turnDesc'),
          key: "turno",
          example: this.$t('guide.csv.example.turn')
        },
        {
          label: this.$t('guide.csv.escalation'),
          description: this.$t('guide.csv.escalationDesc'),
          key: "escalonamento",
          example: this.$t('guide.csv.example.escalation')
        },
        {
          label: this.$t('guide.csv.openingDate'),
          description: this.$t('guide.csv.openingDateDesc'),
          key: "data_abertura_erp",
          example: this.$t('guide.csv.example.openingDate')
        },
        {
          label: this.$t('guide.csv.closingDate'),
          description: this.$t('guide.csv.closingDateDesc'),
          key: "data_fechamento_erp",
          example: this.$t('guide.csv.example.closingDate')
        },
        {
          label: this.$t('guide.csv.startFence'),
          description: this.$t('guide.csv.startFenceDesc'),
          key: "cod_cerca_inicio",
          example: this.$t('guide.csv.example.startFence')
        },
        {
          label: this.$t('guide.csv.endFence'),
          description: this.$t('guide.csv.endFenceDesc'),
          key: "cod_cerca_final",
          example: this.$t('guide.csv.example.endFence')
        },
        {
          label: this.$t('guide.csv.statusCode'),
          description: this.$t('guide.csv.statusCodeDesc'), 
          key: "cod_status_guia",
          example: this.$t('guide.csv.example.statusCode')
        },
        {
          label: this.$t('guide.csv.category'),
          description: this.$t('guide.csv.categoryDesc'),
          key: "cod_classificacao_viagem",
          example: this.$t('guide.csv.example.cod_classificacao_viagem')
        }]
    },
    formTitle() {
      return this.editedIndex === -1 ? this.$t('guide.register') : this.$t('guide.edit');
    },
    formTitleFuncionario() {
      return this.editedIndexFuncionario === -1 ? this.$t('employee.associate') : this.$t('employee.edit');
    },
    dataAtual() {
      var dtAtual = new Date().toISOString().substring(0, 10);
      console.log(dtAtual);
      return dtAtual;
    },
    isFileLoading() {
      return this.fileLoading;
    },
    isProcessFinished() {
      return this.fimProcesso;
    },
    isIdEmpresaDisabled() {
      return this.disableEmpresa;
    },
    isIdClienteDisabled() {
      return this.disableIdLinha;
    },
    isIdRotaDisabled() {
      return this.disableIdRota;
    },
    isDataEscalaDisabled() {
      return this.disableDataEscala;
    },
    isVeiculoDisabled() {
      return this.disableVeiculo;
    },
    isTurnoDisabled() {
      return this.disableTurno;
    },
    isHoraPegadaDisabled() {
      return this.disableHoraPegada;
    },
    isHoraLargadaDisabled() {
      return this.disableHoraLargada;
    },
    isMotoristaDisabled() {
      return this.disableMotorista;
    },
    isCobradorDisabled() {
      return this.disableCobrador;
    },
    isViagemDisabled() {
      return this.disableViagem;
    },
    isPontoPartidaDisabled() {
      return this.disablePontoPartida;
    },
    isPontoChegadaDisabled() {
      return this.disablePontoChegada;
    },
    isStatusDisabled() {
      return this.disableStatus;
    },
    isCodigoDisabled() {
      return this.editedIndex !== -1 || this.disableCodigo;
    },
    isRoletaInicialDisabled() {
      return this.disableRoletaInicial;
    },
    isRoletaFinalDisabled() {
      return this.disableRoletaFinal;
    },
    isQuadroDisabled() {
      return this.disableQuadro;
    },
    isClassificacaoViagemDisabled() {
      return this.disableClassificacaoViagem;
    },
    guiasFiltered() {
      const uid = this.resolveIdUnidade(this.idUnidadeFiltroLista);
      if (uid == null) {
        return this.guias;
      }
      // getguiasdata ja devolve as unidades da linha de cada guia (ids_unidades -> unidades).
      return (this.guias || []).filter(
        (g) =>
          Array.isArray(g.unidades) &&
          g.unidades.map((x) => Number(x)).includes(uid)
      );
    },
    exportHeaders() {
      return (this.headers || []).filter((h) => {
        if (!h || !h.value) return false;
        if (h.value === 'actions' || h.align === ' d-none') return false;
        if (h.to_export === 0 || h.to_export === false) return false;
        if (h.to_export !== undefined && h.to_export !== null) {
          return Number(h.to_export) !== 0;
        }
        return h.to_show === 1 || h.to_show === true || h.show !== false;
      });
    },
    itemsForCsvExport() {
      const displayed = this.displayedItemsForExport;
      const source =
        Array.isArray(displayed) && displayed.length > 0 ? displayed : this.guiasFiltered;
      return Array.isArray(source) ? source : [];
    },
    idUnidadeFormulario() {
      return this.resolveIdUnidade(this.idUnidadeSelecionada);
    },
    quadrosFiltered() {
      const idLinha = this.editedItem.id_linha;
      if (idLinha) {
        return this.quadros.filter((q) => Number(q.id_linha) === Number(idLinha));
      }
      const uid = this.idUnidadeFormulario;
      if (uid == null) {
        return this.quadros;
      }
      const idsLinhasUnidade = this.idsLinhasPorUnidade(uid);
      if (idsLinhasUnidade == null) {
        return this.quadros;
      }
      return this.quadros.filter((q) => idsLinhasUnidade.has(Number(q.id_linha)));
    },
    unidadeLazyExtraData() {
      const uid = this.idUnidadeFormulario;
      if (uid == null) {
        return {};
      }
      return { id_unidade: uid };
    },
    turnosFiltrados() {
      const uid = this.idUnidadeFormulario;
      if (uid == null) {
        return this.turnos;
      }
      return this.turnos.filter(
        (t) => !t.id_unidade || Number(t.id_unidade) === uid
      );
    },
    veiculosFiltrados() {
      const uid = this.idUnidadeFormulario;
      let list = this.veiculos || [];
      if (uid != null) {
        list = list.filter((v) => this.itemPertenceUnidade(v.id_unidade, uid, { allowSemUnidade: true }));
      }
      return this.keepCurrentInList(list, this.veiculos, 'id_veiculo', this.editedItem.id_veiculo);
    },
    motoristasFiltrados() {
      const uid = this.idUnidadeFormulario;
      let list = this.motoristas || [];
      if (uid != null) {
        list = list.filter((f) => this.itemPertenceUnidade(f.id_unidade, uid, { allowSemUnidade: true }));
      }
      return this.keepCurrentInList(list, this.motoristas, 'id_funcionario', this.editedItem.id_motorista);
    },
    cobradoresFiltrados() {
      const uid = this.idUnidadeFormulario;
      let list = this.cobradores || [];
      if (uid != null) {
        list = list.filter((f) => this.itemPertenceUnidade(f.id_unidade, uid, { allowSemUnidade: true }));
      }
      return this.keepCurrentInList(list, this.cobradores, 'id_funcionario', this.editedItem.id_cobrador);
    },
    cercasFiltradas() {
      const idLinha = this.editedItem.id_linha;
      const uid = this.idUnidadeFormulario;
      let list = this.cercas || [];
      if (idLinha) {
        list = list.filter((c) => Number(c.id_linha) === Number(idLinha));
      } else if (uid != null) {
        const idsLinhas = this.idsLinhasPorUnidade(uid);
        if (idsLinhas != null) {
          list = list.filter((c) => idsLinhas.has(Number(c.id_linha)));
        }
      }
      const unique = [];
      const seen = new Set();
      list.forEach((c) => {
        if (c == null || c.id_cerca == null || seen.has(c.id_cerca)) {
          return;
        }
        seen.add(c.id_cerca);
        unique.push(c);
      });
      const withPartida = this.keepCurrentInList(
        unique,
        this.cercas,
        'id_cerca',
        this.editedItem.ponto_partida
      );
      return this.keepCurrentInList(
        withPartida,
        this.cercas,
        'id_cerca',
        this.editedItem.ponto_chegada
      );
    },
  },
  watch: {
    dialog(val) {
      if (val && this.editedIndex === -1) {
        this.$nextTick(() => this.applySingleEmpresaIfOnlyOption());
      }
      val || this.close();
    },
    empresas() {
      if (this.dialog && this.editedIndex === -1) {
        this.$nextTick(() => this.applySingleEmpresaIfOnlyOption());
      }
    },
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    // Quadros e cercas sao pre-filtrados pela unidade enquanto nenhuma linha
    // foi escolhida; o mapa unidade -> linhas vem sob demanda.
    idUnidadeFormulario: {
      handler(uid) {
        this.carregaIdsLinhasDaUnidade(uid);
      },
      immediate: true,
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();
  },
  mounted() {
    this.$root.$emit('eventshowback', true);
  },
  methods: {

    resolveIdUnidade(val) {
      if (val == null || val === '') {
        return null;
      }
      const uid = Number(val);
      return Number.isNaN(uid) ? null : uid;
    },
    /**
     * Ids das linhas da unidade, do cache preenchido por carregaIdsLinhasDaUnidade.
     * Enquanto a busca nao volta devolve null — quem chama nao filtra (mesmo
     * comportamento de antes, quando a lista de linhas ainda nao tinha carregado).
     */
    idsLinhasPorUnidade(uid) {
      const cache = this.idsLinhasPorUnidadeCache[String(uid)];
      return cache != null ? cache : null;
    },
    /** Busca os ids das linhas de uma unidade (getlinhaslazy filtrado por unidade). */
    carregaIdsLinhasDaUnidade(uid) {
      if (uid == null) return;
      const chave = String(uid);
      if (this.idsLinhasPorUnidadeCache[chave] != null) return;
      apiController.request(apiController.endpoints.getLinhaslazy, {
        silent: true,
        data: {
          page: 1,
          pageSize: LINHAS_POR_UNIDADE_PAGE_SIZE,
          search: '',
          showInactives: true,
          id_unidade: uid,
        },
        onSuccess: (response) => {
          const items =
            response.data && Array.isArray(response.data.items) ? response.data.items : [];
          this.$set(
            this.idsLinhasPorUnidadeCache,
            chave,
            new Set(items.map((l) => Number(l.id_linha)))
          );
        },
      });
    },
    itemPertenceUnidade(idUnidadeItem, uid, { allowSemUnidade = false } = {}) {
      if (idUnidadeItem == null || idUnidadeItem === '') {
        return !!allowSemUnidade;
      }
      const n = Number(idUnidadeItem);
      if (Number.isNaN(n)) {
        return !!allowSemUnidade;
      }
      if (allowSemUnidade && n === -1) {
        return true;
      }
      return n === uid;
    },
    keepCurrentInList(filtered, source, key, currentId) {
      if (currentId == null || currentId === '') {
        return filtered;
      }
      if ((filtered || []).some((item) => item && item[key] == currentId)) {
        return filtered;
      }
      const atual = (source || []).find((item) => item && item[key] == currentId);
      return atual ? [...filtered, atual] : filtered;
    },
    applySingleEmpresaIfOnlyOption() {
      if (!this.dialog || this.editedIndex !== -1 || this.disableEmpresa) {
        return;
      }
      if (this.editedItem.id_empresa != null && this.editedItem.id_empresa !== '') {
        return;
      }
      if (!Array.isArray(this.empresas) || this.empresas.length !== 1) {
        return;
      }
      const empresa = this.empresas[0];
      this.editedItem.id_empresa = empresa.id_empresa;
      this.$nextTick(() => {
        this.seedAndSetLazySelect('empresaSelect', 'id_empresa', empresa, empresa.id_empresa);
      });
    },
    onEmpresaInput(val) {
      this.editedItem.id_empresa = val;
    },
    onUnidadeInput(val) {
      this.idUnidadeSelecionada = val;
      if (this.syncingLazySelects) {
        return;
      }
      this.editedItem.id_linha = null;
      this.idQuadroSelected = null;
      this.viagens = [];
      this.editedItem.id_viagem = null;
      this.editedItem.id_veiculo = null;
      this.editedItem.id_motorista = null;
      this.editedItem.id_cobrador = null;
      this.editedItem.ponto_partida = null;
      this.editedItem.ponto_chegada = null;
      this.editedItem.turno = null;
      this.resetLazySelectRef('linhaSelect');
      this.resetLazySelectRef('turnoSelect');
    },
    onLinhaInput(val) {
      this.editedItem.id_linha = val;
      this.carregaDetalheLinha(val);
      if (!this.syncingLazySelects) {
        this.linhaChanged();
      }
    },
    onTurnoInput(val) {
      this.editedItem.turno = val;
    },
    lazySelectRefs() {
      return ['empresaSelect', 'unidadeSelect', 'linhaSelect', 'turnoSelect'];
    },
    resetLazySelectRef(refName) {
      const ref = this.$refs[refName];
      if (ref && typeof ref.resetData === 'function') {
        ref.resetData();
      }
    },
    resetLazySelects() {
      this.syncingLazySelects = true;
      this.lazySelectRefs().forEach((name) => this.resetLazySelectRef(name));
      this.$nextTick(() => {
        this.syncingLazySelects = false;
      });
    },
    seedAndSetLazySelect(refName, valueKey, item, id) {
      const ref = this.$refs[refName];
      if (!ref) {
        return;
      }
      if (item != null && id != null && id !== '' && typeof ref.cacheSelectedItems === 'function') {
        ref.cacheSelectedItems([item], valueKey);
      }
      if (typeof ref.setData === 'function') {
        ref.setData(id != null && id !== '' ? id : null);
      }
      if (typeof ref.loadLazyItems === 'function') {
        ref.loadLazyItems('');
      }
    },
    syncLazySelectsFromEditedItem() {
      this.syncingLazySelects = true;
      const empresa =
        this.empresas.find((e) => e.id_empresa == this.editedItem.id_empresa) ||
        (this.editedItem.id_empresa != null
          ? {
              id_empresa: this.editedItem.id_empresa,
              razao_social: this.editedItem.razao_social,
            }
          : null);
      this.seedAndSetLazySelect('empresaSelect', 'id_empresa', empresa, this.editedItem.id_empresa);

      const unidade = this.unidades.find((u) => u.id_unidade == this.idUnidadeSelecionada);
      this.seedAndSetLazySelect('unidadeSelect', 'id_unidade', unidade, this.idUnidadeSelecionada);

      const linha =
        this.detalheLinhaEditada() ||
        (this.editedItem.id_linha != null
          ? {
              id_linha: this.editedItem.id_linha,
              nome_linha: this.editedItem.nome_linha,
              cod_linha: this.editedItem.cod_linha,
            }
          : null);
      this.seedAndSetLazySelect('linhaSelect', 'id_linha', linha, this.editedItem.id_linha);

      const turno = this.turnos.find((t) => t.id_turno == this.editedItem.turno);
      this.seedAndSetLazySelect('turnoSelect', 'id_turno', turno, this.editedItem.turno);

      this.$nextTick(() => {
        this.syncingLazySelects = false;
      });
    },
    initialize() {
      this.populaConfig();
      this.populaCercas();
      this.populaTurnos();
      this.populaQuadros();
      this.populaUnidades();
      this.populaEmpresas();
      this.populaStatus();
      this.populaClassificacoesViagens();
    },
    populaEmpresasPermitidas() {
      if (Array.isArray(this.recursos)) {
        this.empresasPermitidas = this.recursos.filter((r) => r.id_empresa).map((rec) => {
          return rec.id_empresa
        });
      } else {
        this.empresasPermitidas = [];
      }
    },
    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: (response) => {
            this.recursos = Array.isArray(response.data) ? response.data : [];
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.populaEmpresasPermitidas();
            this.populaGuias();
            this.populaVeiculos();
            this.populaFuncionarios();
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = Array.isArray(response.data) ? response.data : [];
            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updateguia");
            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertguia");
            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deleteguia");
            this.populaEmpresasPermitidas();
            this.populaGuias();
            this.populaVeiculos();
            this.populaFuncionarios();
          },
        });
      }
    },
    populaGuias() {
      this.loadingGuias = true;
      let dti = DateUtils.getDateSQLFormatted(this.dateToFilterLower);
      let dtf = DateUtils.getDateSQLFormatted(this.dateToFilterHigher);
      apiController.request(apiController.endpoints.getGuiasdata, {
        params: { dti, dtf },
        onSuccess: (response) => {
          const data = Array.isArray(response.data) ? response.data : [];
          this.guias = data.filter((g) => this.empresasPermitidas.includes(g.id_empresa));
          this.loadingGuias = false;
        },
        onError: () => {
          this.loadingGuias = false;
        },
      });
    },
    populaClassificacoesViagens() {
      apiController.request(apiController.endpoints.getallClassificacoes, {
        onSuccess: (response) => {
          this.classificacoesViagens = response.data;
          this.classificacoesViagens.forEach(classificacao => {
            classificacao.descricao_classificacao = translateDbField(
              classificacao.translation_key,
              classificacao.descricao_classificacao
            );
            return classificacao;
          });
          console.log(this.classificacoesViagens);
        },
      });
    },
    /**
     * Registro completo de uma linha (velocidade/alarmes/rota/unidades), buscado
     * pontualmente por id no getalllinhas paginado e mantido em cache.
     * O select da tela e lazy e so devolve id/codigo/nome.
     */
    async carregaDetalheLinha(idLinha) {
      if (idLinha == null || idLinha === '') return null;
      const chave = String(idLinha);
      if (this.linhaDetalhePorId[chave] !== undefined) {
        return this.linhaDetalhePorId[chave];
      }
      // Semear o LazySelect tambem emite input: reaproveita a busca em voo.
      if (this.linhaDetalheEmVoo[chave]) {
        return this.linhaDetalheEmVoo[chave];
      }
      // Query montada fora da chamada: um literal aqui viraria allowlist em
      // apiEndpoints (generate:api-endpoints) e descartaria filter_id_linha.
      const consulta = Object.assign(
        { page: 1, rowsPerPage: 1, total: 'true', showInactives: 'true' },
        { filter_id_linha: chave }
      );
      const busca = apiController
        .request(apiController.endpoints.getallLinhas, { data: consulta, silent: true })
        .then((response) => {
          const items =
            response && response.data && Array.isArray(response.data.items)
              ? response.data.items
              : [];
          const linha = items.length ? items[0] : null;
          this.$set(this.linhaDetalhePorId, chave, linha);
          return linha;
        })
        .catch(() => null)
        .then((linha) => {
          delete this.linhaDetalheEmVoo[chave];
          return linha;
        });
      this.linhaDetalheEmVoo[chave] = busca;
      return busca;
    },
    /** Detalhe ja em cache da linha do formulario (sem disparar busca). */
    detalheLinhaEditada() {
      const id = this.editedItem && this.editedItem.id_linha;
      if (id == null || id === '') return null;
      const linha = this.linhaDetalhePorId[String(id)];
      return linha != null ? linha : null;
    },
    /** Busca o detalhe da linha do formulario e re-sincroniza o que depende dele. */
    async atualizaDetalheLinhaEditada() {
      const id = this.editedItem && this.editedItem.id_linha;
      if (id == null || id === '') return;
      await this.carregaDetalheLinha(id);
      this.syncUnidadeFromLinhaIfEditing();
    },
    populaUnidades() {
      apiController.request(apiController.endpoints.getallUnidadesativas, {
        onSuccess: (response) => {
          this.unidades = Array.isArray(response.data) ? response.data : [];
          if (this.dialog) {
            this.$nextTick(() => this.syncLazySelectsFromEditedItem());
          }
        },
      });
    },
    syncUnidadeFromLinhaIfEditing() {
      if (this.editedIndex < 0 || !this.editedItem.id_linha) {
        return;
      }
      const linha = this.detalheLinhaEditada();
      if (linha && Array.isArray(linha.unidades) && linha.unidades.length > 0) {
        this.idUnidadeSelecionada = Number(linha.unidades[0]);
      } else {
        this.idUnidadeSelecionada = null;
      }
    },
    populaTurnos() {
      apiController.request(apiController.endpoints.getallTurnos, {
        onSuccess: (response) => {
          this.turnos = response.data;
          if (this.dialog) {
            this.$nextTick(() => this.syncLazySelectsFromEditedItem());
          }
        },
      });
    },
    populaConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        onSuccess: (response) => {
          this.config = response.data[0];
          [this.dateToFilterLower, this.dateToFilterHigher] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
          this.importar_guias_csv = this.config.importar_guias_csv === 1;
          this.populaRecursos();
        },
      });
    },
    populaStatus() {
      apiController.request(apiController.endpoints.getStatusguias, {
        onSuccess: (response) => {
          this.status = response.data.map((status) => {
            const translated = translateDbField(status.translation_key, status.descricao_status_guia);
            return {
              ...status,
              descricao_status_guia: translated
            };
          });
        },
      });
    },
    populaQuadros() {
      apiController.request(apiController.endpoints.getallQuadrosativos, {
        onSuccess: (response) => {
          this.quadros = response.data;
        },
      });
    },
    populaViagens() {
      if (this.idQuadroSelected) {
        this.getViagens(this.idQuadroSelected);
      } else {
        this.viagens = [];
      }
    },
    getViagens(idQuadro) {
      apiController.request(apiController.endpoints.getallViagensporquadro, {
        params: { id_quadro: idQuadro },
        onSuccess: (response) => {
          this.viagens = response.data;
        },
      });
    },
    populaCercas() {
      apiController.request(apiController.endpoints.getallCercasativas, {
        onSuccess: (response) => {
          this.cercas = response.data;
        },
      });
    },
    populaFuncionarios() {
      apiController.request(apiController.endpoints.getallFuncionarios, {
        silent: true,
        onSuccess: (response) => {
          this.funcionarios = response.data;
          this.populaMotoristas();
          this.populaCobradores();
        },
        onError: (e) => {
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              this.$t('system.messages.accessDenied');
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    populaMotoristas() {
      this.motoristas = this.funcionarios.filter((f) => f.categoria_extenso === "Motorista");
    },
    populaCobradores() {
      this.cobradores = this.funcionarios.filter((f) => f.categoria_extenso === "Cobrador");
    },
    // populaFuncionariosGuia(idguia) {
    //   this.loadingfuncionarios = true;
    //   apiController.request(apiController.endpoints.getFuncionariosguia, {
    //     params: { idguia: idguia },
    //     onSuccess: (response) => {
    //       this.funcionariosGuia = response.data;
    //       this.editedItem.motorista = this.funcionariosGuia.find((f) => f.categoria_extenso === 'Motorista');
    //       this.editedItem.cobrador = this.funcionariosGuia.find((f) => f.categoria_extenso === 'Cobrador');
    //       this.loadingfuncionarios = false;
    //     },
    //     onError: (e) => {
    //       console.log(this.$t('system.messages.errorAxios'));
    //       console.log(e.message);
    //       if (e.message == "Request failed with status code 401") {
    //         this.mensagemAutorizacaoDialog =
    //           this.$t('system.messages.accessDenied');
    //         this.autorizacaoDialog = true;
    //       }
    //     },
    //   });
    // },
    populaVeiculos() {
      apiController.request(apiController.endpoints.getallVeiculosativos, {
        silent: true,
        onSuccess: (response) => {
          const data = Array.isArray(response.data) ? response.data : [];
          this.veiculos = data;
        },
        onError: (e) => {
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              this.$t('system.messages.accessDenied');
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        silent: true,
        onSuccess: (response) => {
          this.empresas = response.data;
          if (this.dialog) {
            this.$nextTick(() => {
              this.applySingleEmpresaIfOnlyOption();
              this.syncLazySelectsFromEditedItem();
            });
          }
        },
        onError: (e) => {
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              this.$t('system.messages.accessDenied');
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    horarioRules(hora) {
      if (hora == null) {
        return this.$t('datetime.requiredTime');
      } else {
        if (hora.length === 0) {
          return this.$t('datetime.requiredTime');
        } else {
          if (!/(([01][0-9])|(2[0-3])):([0-5][0-9])$/.test(hora)) {
            return this.$t('datetime.invalidTime');
          } else {
            return true;
          }
        }
      }
    },
    editItem(item) {
      this.guiaEditSnapshot = this.buildGuiaComparableSnapshot(item);
      this.guiaOriginal = Object.assign({}, item);
      this.guiaOriginal.alteracao_manual = 1;
      this.guiaOriginal.dt_alteracao_manual = DateUtils.getDateSQLFormatted(new Date());
      this.guiaOriginal.id_usuario_alteracao_manual = this.user.id_usuario;
      this.editedIndex = this.guias.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.horaPegadaProgramada = new Date(this.editedItem.data_hora_pegada);
      this.horaLargadaProgramada = this.editedItem.data_hora_largada ? new Date(this.editedItem.data_hora_largada) : null;
      this.disableRoletaFinal = false;
      this.ensureFormDataLoaded();
      this.resolveQuadroForViagem(this.editedItem.id_linha, this.editedItem.id_viagem);
      this.dialog = true;
      this.atualizaDetalheLinhaEditada().then(() => {
        this.$nextTick(() => this.syncLazySelectsFromEditedItem());
      });
    },
    ensureFormDataLoaded() {
      if (!this.veiculos.length) {
        this.populaVeiculos();
      }
    },
    resolveQuadroForViagem(idLinha, idViagem) {
      this.idQuadroSelected = null;
      this.viagens = [];
      if (!idViagem || !idLinha) {
        return;
      }
      const candidatos = this.quadros.filter((q) => Number(q.id_linha) === Number(idLinha));
      const tryNext = (index) => {
        if (index >= candidatos.length) {
          return;
        }
        const quadro = candidatos[index];
        apiController.request(apiController.endpoints.getallViagensporquadro, {
          params: { id_quadro: quadro.id_quadro },
          onSuccess: (response) => {
            const viagensQuadro = Array.isArray(response.data) ? response.data : [];
            if (viagensQuadro.some((v) => Number(v.id_viagem) === Number(idViagem))) {
              this.idQuadroSelected = quadro.id_quadro;
              this.viagens = viagensQuadro;
            } else {
              tryNext(index + 1);
            }
          },
        });
      };
      tryNext(0);
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.deletedItem.alteracao_manual = 1;
      this.deletedItem.dt_alteracao_manual = DateUtils.getDateSQLFormatted(new Date());
      this.deletedItem.id_usuario_alteracao_manual = this.user.id_usuario;
      this.mensagemdialog =
        this.$t('datetime.confirmDeactivateGuide') + " " + item.id_guia + " ?";
      this.showConfirmButton = true;
      this.confirmDialog = true;
    },
    deleteItemFuncionario(item) {
      this.funcionariosGuia.splice(
        this.funcionariosGuia.findIndex((a) => a.id_funcionario === item.id_funcionario),
        1
      );
    },
    applyCanceledStatus(guia) {
      const canceled = (this.status || []).find(
        (s) => s.cod_status === "C" || s.translation_key === "database.guideStatus.canceled"
      );
      if (canceled) {
        guia.status = canceled.id_status_guia;
        guia.status_extenso = canceled.descricao_status_guia;
      } else {
        guia.status = 4;
        guia.status_extenso = "Cancelada";
      }
    },
    guiaFieldEqual(a, b) {
      const norm = (v) => {
        if (v == null || v === "") {
          return null;
        }
        const n = Number(v);
        if (!Number.isNaN(n) && String(v).trim() !== "") {
          return n;
        }
        return String(v);
      };
      return norm(a) === norm(b);
    },
    buildGuiaComparableSnapshot(item) {
      return {
        id_empresa: item.id_empresa,
        guia_original: item.guia_original,
        roleta_inicial: item.roleta_inicial,
        roleta_final: item.roleta_final,
        id_linha: item.id_linha,
        id_veiculo: item.id_veiculo,
        turno: item.turno,
        escalonamento: item.escalonamento,
        hora_pegada: item.data_hora_pegada
          ? DateUtils.getDateSQLFormatted(new Date(item.data_hora_pegada))
          : null,
        hora_largada: item.data_hora_largada
          ? DateUtils.getDateSQLFormatted(new Date(item.data_hora_largada))
          : null,
        id_motorista: item.id_motorista,
        id_cobrador: item.id_cobrador,
        id_viagem: item.id_viagem,
        ponto_partida: item.ponto_partida,
        ponto_chegada: item.ponto_chegada,
        id_classificacao_viagem: item.id_classificacao_viagem,
        status: item.status,
      };
    },
    buildGuiaComparableSnapshotFromForm() {
      return {
        id_empresa: this.editedItem.id_empresa,
        guia_original: this.editedItem.guia_original,
        roleta_inicial: this.editedItem.roleta_inicial,
        roleta_final: this.editedItem.roleta_final,
        id_linha: this.editedItem.id_linha,
        id_veiculo: this.editedItem.id_veiculo,
        turno: this.editedItem.turno,
        escalonamento: this.editedItem.escalonamento,
        hora_pegada: this.editedItem.hora_pegada,
        hora_largada: this.editedItem.hora_largada,
        id_motorista: this.editedItem.id_motorista,
        id_cobrador: this.editedItem.id_cobrador,
        id_viagem: this.editedItem.id_viagem,
        ponto_partida: this.editedItem.ponto_partida,
        ponto_chegada: this.editedItem.ponto_chegada,
        id_classificacao_viagem: this.editedItem.id_classificacao_viagem,
        status: this.editedItem.status,
      };
    },
    isOnlyStatusChange() {
      if (!this.guiaEditSnapshot) {
        return false;
      }
      const snapshot = this.guiaEditSnapshot;
      const current = this.buildGuiaComparableSnapshotFromForm();
      const fieldsExceptStatus = [
        "id_empresa",
        "guia_original",
        "roleta_inicial",
        "roleta_final",
        "id_linha",
        "id_veiculo",
        "turno",
        "escalonamento",
        "hora_pegada",
        "hora_largada",
        "id_motorista",
        "id_cobrador",
        "id_viagem",
        "ponto_partida",
        "ponto_chegada",
        "id_classificacao_viagem",
      ];
      const statusChanged = !this.guiaFieldEqual(snapshot.status, current.status);
      if (!statusChanged) {
        return false;
      }
      return fieldsExceptStatus.every((field) =>
        this.guiaFieldEqual(snapshot[field], current[field])
      );
    },
    hasOriginalPickupTimePassed() {
      if (!this.guiaOriginal || !this.guiaOriginal.data_hora_pegada) {
        return false;
      }
      const pickup = new Date(this.guiaOriginal.data_hora_pegada);
      return !isNaN(pickup.getTime()) && pickup.getTime() <= Date.now();
    },
    shouldUpdateExistingGuia() {
      if (this.isOnlyStatusChange()) {
        return true;
      }
      return !this.hasOriginalPickupTimePassed();
    },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;
      this.applyCanceledStatus(this.deletedItem);
      apiController.request(apiController.endpoints.deleteGuia, {
        data: this.deletedItem,
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
      });
    },
    close() {
      this.dialog = false;
      this.disableEmpresa = false;
      this.disableIdLinha = false;
      this.disableIdRota = false;
      this.disableDataEscala = false;
      this.disableHoraPegada = false;
      this.disableHoraLargada = false;
      this.disableVeiculo = false;
      this.disableStatus = false;
      this.disableMotorista = false;
      this.disableCobrador = false;
      this.disableTurno = false;
      this.disableCodigo = false;
      this.disableRoletaInicial = false;
      this.disableRoletaFinal = true;
      this.disableQuadro = false;
      this.idQuadroSelected = null;
      // this.disableQtdDias = true;
      this.funcionariosGuia = [];
      this.isAtivo = false;
      // this.clientes = [];
      // this.rotas = [];
      this.veiculos = [];
      this.viagens = [];
      // Detalhe da linha e relido a cada abertura do formulario (era o efeito do
      // antigo this.linhas = [] + ensureFormDataLoaded).
      this.linhaDetalhePorId = {};
      this.linhaDetalheEmVoo = {};
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.guiaOriginal = null;
        this.guiaEditSnapshot = null;
        this.editedIndex = -1;
        this.isAtivo = false;
        this.idUnidadeSelecionada = null;
        this.horaPegadaProgramada = null;
        this.horaLargadaProgramada = null;
        this.resetLazySelects();
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },
    async save() {
      this.$refs.form.validate();
      if (this.formValidado) {
        // O select de linha e lazy: garante o registro completo (rota, alarmes,
        // velocidade) antes de copiar esses campos para a guia.
        await this.carregaDetalheLinha(this.editedItem.id_linha);
        this.editedItem.hora_pegada = DateUtils.getDateSQLFormatted(this.horaPegadaProgramada);
        this.editedItem.hora_largada = this.horaLargadaProgramada ? DateUtils.getDateSQLFormatted(this.horaLargadaProgramada) : null;
        this.editedItem.alteracao_manual = 1;
        this.editedItem.dt_alteracao_manual = DateUtils.getDateSQLFormatted(new Date());
        this.editedItem.id_usuario_alteracao_manual = this.user.id_usuario;

        let veiculo = this.veiculos.find((v) => this.editedItem.id_veiculo == v.id_veiculo);
        if (veiculo) {
          this.editedItem.cod_veiculo = veiculo.numero_ordem;
          this.editedItem.placa = veiculo.placa;
        }

        let linha = this.detalheLinhaEditada();
        if (linha) {
          this.editedItem.cod_linha = linha.cod_linha;
          this.editedItem.cod_linha_guia = linha.cod_integracao_linha;
          this.editedItem.nome_linha = linha.nome_linha;
          this.editedItem.id_rota = linha.id_rota;
          this.editedItem.velocidade_maxima = linha.velocidade_maxima;
          this.editedItem.alarme_velocidade_maxima = linha.alarme_velocidade_maxima;
          this.editedItem.alarme_fora_rota = linha.alarme_fora_rota;
          this.editedItem.circular = linha.circular;
          this.editedItem.alarme_tempo_parado = linha.alarme_tempo_parado;
          this.editedItem.limite_tempo_parado = linha.limite_tempo_parado;
        }

        if (this.editedItem.id_motorista) {
          let motorista = this.funcionarios.find((v) => this.editedItem.id_motorista == v.id_funcionario);
          this.editedItem.id_motorista = motorista.id_funcionario;
          this.editedItem.nome_motorista = motorista.nome;
          this.editedItem.matricula_motorista = motorista.matricula;
          this.editedItem.cod_motorista_guia = motorista.matricula;
        }

        if (this.editedItem.id_cobrador) {
          let cobrador = this.funcionarios.find((v) => this.editedItem.id_cobrador == v.id_funcionario);
          this.editedItem.id_cobrador = cobrador.id_funcionario;
          this.editedItem.nome_cobrador = cobrador.nome;
          this.editedItem.matricula_cobrador = cobrador.matricula;
          this.editedItem.cod_cobrador_guia = cobrador.matricula;
        }

        if (this.editedItem.ponto_partida) {
          let pontoPartida = this.cercas.find((c) => this.editedItem.ponto_partida == c.id_cerca);
          this.editedItem.id_cerca_inicio = pontoPartida.id_cerca;
          this.editedItem.nome_cerca_inicio = pontoPartida.nome_cerca;
          this.editedItem.cod_cerca_inicio = pontoPartida.cod_cerca;
        }

        if (this.editedItem.ponto_chegada) {
          let pontoChegada = this.cercas.find((c) => this.editedItem.ponto_chegada == c.id_cerca);
          this.editedItem.id_cerca_final = pontoChegada.id_cerca;
          this.editedItem.nome_cerca_final = pontoChegada.nome_cerca;
          this.editedItem.cod_cerca_final = pontoChegada.cod_cerca;
        }

        let empresa = this.empresas.find((e) => e.id_empresa == this.editedItem.id_empresa);
        if (empresa) {
          this.editedItem.razao_social = empresa.razao_social;
        }

        let status = this.status.find((s) => this.editedItem.status == s.id_status_guia);
        if (status) {
          this.editedItem.status_extenso = status.descricao_status_guia;
        }

        if (this.editedIndex == -1) {
          this.editedItem.data_abertura_erp = DateUtils.getDateSQLFormatted(new Date());
          this.editedItem.ativa = true;
          this.editedItem.origem = 'CADASTRO';
          this.operacao = 0;
          apiController.request(apiController.endpoints.insertGuia, {
            data: this.editedItem,
            onSuccess: (response) => {
              this.insertFuncionariosBulk(response.data.insertId);
            },
          });
        } else if (this.shouldUpdateExistingGuia()) {
          if (this.editedItem.ativa == null) {
            this.editedItem.ativa = this.guiaOriginal.ativa != null ? this.guiaOriginal.ativa : 1;
          }
          this.operacao = 1;
          apiController.request(apiController.endpoints.updateGuia, {
            data: this.editedItem,
            onSuccess: () => {
              this.updateFuncionarios();
            },
          });
        } else {
          this.operacao = 0;
          const novaGuia = Object.assign({}, this.editedItem);
          delete novaGuia.id_guia;
          novaGuia.data_abertura_erp = DateUtils.getDateSQLFormatted(new Date());
          novaGuia.ativa = true;

          this.applyCanceledStatus(this.guiaOriginal);
          apiController.request(apiController.endpoints.deleteGuia, {
            data: this.guiaOriginal,
            onSuccess: () => {
              apiController.request(apiController.endpoints.insertGuia, {
                data: novaGuia,
                onSuccess: (response) => {
                  this.insertFuncionariosBulk(response.data.insertId);
                },
              });
            },
          });
        }
      }
    },
    editItemFuncionario(item) {
      this.editedItemFuncionario = Object.assign({}, item);
      this.editingFuncionarios = true;
      this.dialogFuncionarios = true;
    },
    closeDialogFuncionarios() {
      this.dialogFuncionarios = false;
      this.$nextTick(() => {
        this.editedItemFuncionario = Object.assign({}, this.defaultItemFuncionario);
        if (this.$refs.formFuncionarios) {
          this.$refs.formFuncionarios.resetValidation();
        }
        this.editingFuncionarios = false;
      });
    },
    insertFuncionariosBulk(idGuia) {
      var temp = [];

      if (this.editedItem.id_motorista) {
        temp.push([
          this.editedItem.id_motorista,
          idGuia]);
      }

      if (this.editedItem.id_cobrador) {
        temp.push([
          this.editedItem.id_cobrador,
          idGuia]);
      }

      apiController.request(apiController.endpoints.insertFuncionariosguiabulk, {
        data: temp,
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
      });
    },
    updateFuncionarios() {
      apiController.request(apiController.endpoints.deleteFuncionariosguia, {
        data: this.editedItem,
        onSuccess: () => {
          this.insertFuncionariosBulk(this.editedItem.id_guia);
        },
      });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    updateTable(status) {
      if (status) {
        if (this.operacao == 0) {
          EventBus.$emit('show-alert', { mensagem: this.$t('guide.alerts.error.insert'), tipo: 'error' });
        } else {
          if (this.operacao == 1) {
            EventBus.$emit('show-alert', { mensagem: this.$t('guide.alerts.error.update'), tipo: 'error' });
          } else {
            EventBus.$emit('show-alert', { mensagem: this.$t('guide.alerts.error.delete'), tipo: 'error' });
          }
        }
      } else {
        if (this.operacao == 0) {
          EventBus.$emit('show-alert', { mensagem: this.$t('guide.alerts.success.insert'), tipo: 'success' });
        } else {
          if (this.operacao == 1) {
            EventBus.$emit('show-alert', { mensagem: this.$t('guide.alerts.success.update'), tipo: 'success' });
          } else {
            EventBus.$emit('show-alert', { mensagem: this.$t('guide.alerts.success.delete'), tipo: 'success' });
          }
        }
        this.editedItem = this.defaultItem;
      }
      this.close();
      this.closeDialogFuncionarios();
      this.initialize();
    },
    linhaChanged() {
      this.idQuadroSelected = null;
      this.viagens = [];
      this.editedItem.id_viagem = null;
      this.populaCercas(this.editedItem.id_linha);
    },
    isGuiaEditable(item) {
      return !this.config.guias_automaticas && !!item.is_editable;
    },
    showUploadDialog() {
      this.arquivoCsv = null;
      this.fimProcesso = false;
      this.mensagemUpload = null;
      this.fileLoading = false;
      this.uploadDialog = true;
    },
    closeUploadDialog() {
      if (this.$refs.formUpload) {
        this.$refs.formUpload.resetValidation();
      }
      this.arquivoCsv = null;
      this.arquivoLog = null;
      this.uploadDialog = false;
      this.resultCSV = [];
      this.uploadResultDialog = false;
      this.initialize();
    },
    saveBulk(guias) {
      if (guias.length > 0) {
        let temp = guias.map((g) => {
          return [
            g.id_linha,
            g.id_veiculo,
            g.id_status_guia,
            g.data_hora_pegada,
            g.data_hora_largada,
            g.turno,
            g.dt_alteracao_manual,
            g.id_usuario_alteracao_manual,
            g.id_viagem,
            g.id_cerca_inicio,
            g.id_cerca_final,
            g.escalonamento,
            g.data_abertura_erp,
            g.data_fechamento_erp,
            g.cod_veiculo,
            g.id_empresa,
            g.placa,
            g.nome_linha,
            g.cod_linha,
            g.cod_linha_guia,
            g.id_rota,
            g.velocidade_maxima,
            g.alarme_velocidade_maxima,
            g.alarme_fora_rota,
            g.circular,
            g.alarme_tempo_parado,
            g.limite_tempo_parado,
            g.id_motorista,
            g.matricula_motorista,
            g.nome_motorista,
            g.cod_motorista_guia,
            g.id_cobrador,
            g.matricula_cobrador,
            g.nome_cobrador,
            g.cod_cobrador_guia,
            g.razao_social,
            g.shape_cerca_inicio,
            g.shape_cerca_final,
            g.ativa,
            g.roleta_inicial,
            g.status_extenso,
            g.guia_original,
            g.origem || 'CSV',
            g.id_classificacao_viagem
          ];
        })
        // O diálogo do CSV fecha no clique: sem o overlay, um lote grande parecia não fazer nada.
        this.operacao = 0;
        this.savingBulkTotal = temp.length;
        this.savingBulk = true;
        apiController.request(apiController.endpoints.insertGuiasbulk, {
          data: temp,
          onSuccess: (response) => {
            this.savingBulk = false;
            this.uploadResultDialog = false;
            this.updateTable(response.data.erro);
          },
          onError: () => {
            this.savingBulk = false;
            this.uploadResultDialog = false;
          },
        });
      }
    },
    onQuadroChanged() {
      this.populaViagens();
    }
  },
};
</script>